import { render, staticRenderFns } from "./SrProcessAndRequirements.vue?vue&type=template&id=af5e9814&scoped=true&"
import script from "./SrProcessAndRequirements.vue?vue&type=script&lang=ts&"
export * from "./SrProcessAndRequirements.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af5e9814",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
